module.exports = __webpack_public_path__ + "static/media/roboto-italic.51521a2a.woff2";